var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Home"}},[_c('HomeTopImage'),_c('EnquireyBanner'),_c('div',{attrs:{"id":"about"}},[_c('SimSection')],1),_c('div',{attrs:{"id":"membership"}},[_c('ThrillSection')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }